import { BCDataGrid } from '../../BCDataGrid';
import { IDefinition } from '../entities';

export function setOptionColumnsCellValue(
	this: BCDataGrid.Entities.IColumnProps,
	newData: Partial<IDefinition>,
	value: boolean
) {
	newData.selectedOptionKey = value ? this.name : null;
}
